export const iconFontAwesomeFilesFileCircleMinus = (
	<i className="fa-solid fa-file-circle-minus"></i>
);
